export default __webpack_public_path__ + "static/media/geofence.dffa1c57.jpg";